import React, { useRef } from 'react';
import './FileUploader.scss';
import { FilesComponentsProps } from './files.types';

import { IoDocumentAttach } from 'react-icons/io5';
import { Button } from 'components/Button/Button';
import { useFlowTs } from 'utils/useFlowTs';
import uploadIcon from 'assets/images/icons/upload-icon.svg';

export const FileUploader: React.FC<FilesComponentsProps> = ({ files, setFiles, size, label, variant, icon, onSuccess }) => {
    const { flow } = useFlowTs({ setFiles, onSuccess });

    const inputRef = useRef<HTMLInputElement>(null);

    const handleOpenFileBrowser = () => {
        inputRef.current?.click();
    };

    return (
        <div className="file-uploader">
            {(!size || size === 'normal') && (
                <>
                    <Button
                        label={label ?? 'Joindre un fichier'}
                        variant={variant ?? 'dark'}
                        icon={icon ?? <IoDocumentAttach />}
                        iconBefore
                        callback={handleOpenFileBrowser}
                        type='button'
                    />

                    <input
                        id="file-uploader"
                        className="file-input"
                        type="file"
                        ref={inputRef}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            const targetFiles: FileList | null = e.target.files;
                            if (targetFiles && flow) {
                                Array.from(targetFiles).forEach((file) => {
                                    flow.addFile(file);
                                });
                            }
                        }}
                    />
                </>
            )}
            {size === 'big' && (
                <>
                    <div className="file-upload-button" onClick={handleOpenFileBrowser}>
                        <input
                            id="file-uploader"
                            className="file-input"
                            type="file"
                            ref={inputRef}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                const targetFiles: FileList | null = e.target.files;
                                if (targetFiles && flow) {
                                    Array.from(targetFiles).forEach((file) => {
                                        flow.addFile(file);
                                    });
                                }
                            }}
                        />
                        <img src={uploadIcon} alt="Icône d'ajout de fichier" />
                        <p>
                            <strong>Importer un document</strong>
                            <br />
                            ou déposer le fichier ici
                        </p>
                    </div>
                </>
            )}
        </div>
    );
};
